<template>
  <div class="home">
    <div class="main-content" style="margin-top: 0px">
      <!-- HEADER -->
      <div class="pb-8 bg-dark bg-ellipses">
        <div class="row justify-content-center">
          <div class="col-md-10 col-lg-8 col-xl-6">
            <!-- Title -->
            <h1 class="display-3 text-center text-white">Seja vip!</h1>

            <!-- Text -->
            <p class="lead text-center text-muted">
              Tenha análise completa de partidas para profitar cada vez mais.
            </p>
          </div>
        </div>
        <!-- / .row -->
      </div>

      <!-- CONTENT -->
      <div class>
        <div class="row mt-n7">
          <div class="col-12 col-lg-4">
            <!-- Card -->
            <div class="card">
              <div class="card-body">
                <!-- Title -->
                <h6 class="text-uppercase text-center text-muted my-4">
                  Plano Vip
                </h6>

                <!-- Price -->
                <div
                  class="
                    row
                    no-gutters
                    align-items-center
                    justify-content-center
                  "
                >
                  <div class="col-auto">
                    <div class="h2 mb-0">R$</div>
                  </div>
                  <div class="col-auto">
                    <div class="display-2 mb-0">20,00</div>
                  </div>
                </div>
                <!-- / .row -->

                <!-- Period -->
                <div class="h6 text-uppercase text-center text-muted mb-5">
                  / mês
                </div>

                <!-- Features -->
                <div class="mb-3">
                  <ul class="list-group list-group-flush">
                    <li
                      class="
                        list-group-item
                        d-flex
                        align-items-center
                        justify-content-between
                        px-0
                      "
                    >
                      <small>Controle de apostas</small>
                      <i class="fe fe-check-circle text-success"></i>
                    </li>
                    <li
                      class="
                        list-group-item
                        d-flex
                        align-items-center
                        justify-content-between
                        px-0
                      "
                    >
                      <small>Análise de partidas para apostas</small>
                      <i class="fe fe-check-circle text-success"></i>
                    </li>

                    <li
                      class="
                        list-group-item
                        d-flex
                        align-items-center
                        justify-content-between
                        px-0
                      "
                    >
                      <small
                        >Análise de partidas BOOST para apostas (estatisticas
                        com +70% chance de vitória)</small
                      >
                      <i class="fe fe-check-circle text-success"></i>
                    </li>
                    <li
                      class="
                        list-group-item
                        d-flex
                        align-items-center
                        justify-content-between
                        px-0
                      "
                    >
                      <small>Calls de apostas pela equipe</small>
                      <i class="fe fe-check-circle text-success"></i>
                    </li>
                  </ul>
                </div>

                <!-- Button -->
                <a
                  href="#"
                  class="btn btn-block btn-primary"
                  @click.prevent="criarlink('mensal')"
                  >Comprar!</a
                >
                <!-- <a href="https://api.whatsapp.com/send?phone=5538988138328&text=Gostaria%20de%20Assinar%20o%20plano%20Vip" class="btn btn-block btn-primary" @click="criarlink()">
                  Comprar!
                </a>-->
              </div>
            </div>
          </div>
        </div>
        <!-- / .row -->
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="card card-inactive">
              <div class="card-body">
                <h3 class="text-center">Precisa de ajuda para decidir?</h3>
                <p class="text-muted text-center">
                  Contate-nos através do link abaixo.
                </p>
                <div class="text-center">
                  <a
                    href="https://discordapp.com/users/232968635075919872/"
                    class="btn btn-outline-secondary"
                  >
                    Contato
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="card card-inactive">
              <div class="card-body">
                <h3 class="text-center">Seja vip pela Rivalry!</h3>
                <p class="text-muted text-center">
                  Cadastre-se pelo link acima, efetue seu primeiro depósito e
                  ganhe 3 meses de vip no site. Para concluir o processo de
                  liberação do plano, entre em contato conosco.
                </p>
                <div class="text-center">
                  <a
                    href="https://discordapp.com/users/232968635075919872/"
                    class="btn btn-outline-secondary"
                  >
                    Contato
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- / .main-content -->
</template>

<script>
import axios from 'axios'

  export default {
    data: function () {
      return {
        logado: false,
        showLogado: false
      }
    },
    mounted(){
        console.log(this.showLogado)
        if (this.$store.state.isAuthenticated == true) {
            this.logado = true
        } else {
            this.logado = false
            // this.$router.push({name: 'Login'})
        }
    },
    methods:{
        criarlink(tipo){
        const config = {
            headers: {
        // Set your Authorization to 'JWT', not Bearer!!!
        Authorization: `JWT ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
        },
        }
        axios.get(`dinheiros/get_transaction/${tipo}`,config)
        .then(resp => {
          var link = resp.data
          window.open(link, '_blank')
        })
      }
    }
  }
</script>

<style>
</style>